exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a{\n  cursor: pointer;\n}\n\n.date-th{\n  min-width: 150px;\n}\n\n.place{\n  max-width: 100px;\n}\n\n.ui.table tr.positive{\n  background: rgb(210, 242, 186) !important;\n}\n.vehicle-cell{\n  max-width: 100px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/demand/demand.component.css
// module id = ../../../../../src/app/_components/demand/demand.component.css
// module chunks = main